<script setup lang="ts">
import RangeSliderInput from '@components/RangeSliderInput.vue';
import { trans } from '@tools/translation.ts';
import { range } from 'lodash-es';
import { ref } from 'vue';
import Typography from '@components/Typography.vue';
import Icon from '@components/Icon.vue';
import { IconArrowRight, IconRulerMagic } from '@icons';

// @todo : move to store, @see https://bureaux-a-partager.atlassian.net/browse/MATCH-10559
const surfaceMin = ref<number | null>(null);
const surfaceMax = ref<number | null>(null);
</script>

<template>
  <div class="flex flex-col gap-4 p-3 lg:p-4">
    <RangeSliderInput
      v-model:min-value="surfaceMin"
      v-model:max-value="surfaceMax"
      :values="[
        ...range(0, 100, 10),
        ...range(100, 500, 50),
        ...range(500, 1500 + 100, 100),
      ]"
      :major-ticks="[ 0, 100, 500, 1500 ]"
      input-container-class="lg:w-42"
      :min-label="trans('search.filters.surface.min')"
      :max-label="trans('search.filters.surface.max')"
      :unit="trans('search.filters.surface.placeholder')"
    />

    <a
      href="https://calculateur-surface.ubiq.fr"
      :class="[
        'rounded-lg',
        'p-2',
        'flex items-center gap-x-2',
        'bg-purple-lighter',
        'text-purple no-underline hover:text-purple',
        'group'
      ]"
    >
      <Icon
        :svg="IconRulerMagic"
        width="24"
        height="24"
        class="shrink-0"
      />

      <Typography
        variant="body-small"
        color="purple"
        class="group-hover:underline"
      >
        {{ trans('search.filters.surface.calculator.link') }}
      </Typography>

      <Icon
        :svg="IconArrowRight"
        width="16"
        height="16"
        fill="purple"
        class="shrink-0"
      />
    </a>
  </div>
</template>
